import { Fragment } from 'react';
import { useChartContext, LINE_HEIGHT, FONT_SIZE } from '@shopify/polaris-viz-core';
import { endLineTruncate } from './utilities/endLineTruncate.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SingleTextLine({
  ariaHidden = false,
  color,
  dominantBaseline = 'hanging',
  targetWidth,
  text,
  textAnchor = 'center',
  y,
  x
}) {
  const {
    characterWidths
  } = useChartContext();
  const truncated = endLineTruncate({
    label: text,
    targetWidth,
    targetHeight: LINE_HEIGHT,
    characterWidths
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("text", {
      "aria-hidden": ariaHidden,
      textAnchor: textAnchor,
      dominantBaseline: dominantBaseline,
      height: LINE_HEIGHT,
      width: targetWidth,
      fill: color,
      fontSize: FONT_SIZE,
      y: y,
      x: x,
      children: truncated
    }), /*#__PURE__*/jsx("title", {
      children: text
    })]
  });
}

export { SingleTextLine };
